import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Rooms = () => {
   const { t } = useTranslation();
    const [modalImages, setModalImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleImageClick = (images, index = 0) => {
        setModalImages(images);
        setCurrentIndex(index);
        window.$('#imageModal').modal('show');
    };


    return (
        <section className="rooms-section spad fade-in">
            <div className="container" style={{maxWidth:"1580px"}}> 
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div className="room-item">
                        <h4>{t('rooms.sup1')}</h4>
                        <h3><span></span></h3>
                            <img src="./img/rooms/Superior2SpaceApart4ppl/1.jpg" alt="Rafkon Superior Appartment"
                             onClick={() =>
                                    handleImageClick([
                                        './img/rooms/Superior2SpaceApart4ppl/1.jpg',
                                        './img/rooms/Superior2SpaceApart4ppl/2.jpg',
                                        './img/rooms/Superior2SpaceApart4ppl/3.jpg',
                                        './img/rooms/Superior2SpaceApart4ppl/4.jpg',
                            

                                    ])
                                }/>
                            <div class="ri-text">
                                
                                
                                <table className="table table-responsive">
                                    <tbody>
                                        <tr>
                                            <td class="r-o">{t('rooms.size')}</td>
                                            <td>40 {t('rooms.sizedesc')}</td>
                                        </tr>
                                        <tr>
                                            <td class="r-o">{t('rooms.desc')}</td>
                                            <td>{t('rooms.desc1')}</td>
                                        </tr>
                                        <tr>
                                            <td class="r-o">{t('rooms.capacity')}</td>
                                            <td>{t('rooms.capacitydesc1')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.beds')}</td>
                                            <td>{t('rooms.bedsdesc')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.services')}</td>
                                            <td>{t('rooms.servicesdesc')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <a target="_blank"
                                    rel="noopener noreferrer" href="https://www.booking.com/hotel/gr/rafkon-myrina-apartments.en-gb.html?lang=en-gb&soz=1&lang_changed=1#room_1026666601" class="primary-btn">{t('rooms.more')}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div className="room-item">
                        <h4>{t('rooms.sup1')}</h4>
                        <h3><span></span></h3>
                            <img src="./img/rooms/Superior2SpaceApart3ppl/1.jpg" alt="Rafkon Superior Appartment" 
                            onClick={() =>
                                    handleImageClick([
                                        './img/rooms/Superior2SpaceApart3ppl/1.jpg',
                                        './img/rooms/Superior2SpaceApart3ppl/2.jpg',
                                        './img/rooms/Superior2SpaceApart3ppl/3.jpg',
                                         './img/rooms/Superior2SpaceApart3ppl/4.jpg',

                                    ])
                                } />
                            <div class="ri-text">
                                
                                
                                <table className="table table-responsive">
                                    <tbody>
                                        <tr>
                                            <td class="r-o">{t('rooms.size')}</td>
                                            <td>40 {t('rooms.sizedesc')}</td>
                                        </tr>

                                         <tr>
                                            <td class="r-o">{t('rooms.desc')}</td>
                                            <td>{t('rooms.desc2')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.capacity')}</td>
                                            <td>{t('rooms.capacitydesc2')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.beds')}</td>
                                            <td>{t('rooms.bedsdesc')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.services')}</td>
                                            <td>{t('rooms.servicesdesc')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <a target="_blank"
                                    rel="noopener noreferrer" href="https://www.booking.com/hotel/gr/rafkon-myrina-apartments.en-gb.html?lang=en-gb&soz=1&lang_changed=1#room_1026666601" class="primary-btn">{t('rooms.more')}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div className="room-item">
                        <h4>{t('rooms.sup2')}</h4>
                        <h3><span></span></h3>
                            <img src="./img/rooms/SuperiorStudioApartment/1.jpg" alt="Rafkon Superior Appartment 2" 
                            onClick={() =>
                                    handleImageClick([
                                        './img/rooms/SuperiorStudioApartment/1.jpg',
                                        './img/rooms/SuperiorStudioApartment/2.jpg',
                                        './img/rooms/SuperiorStudioApartment/3.jpg',
                                        // './img/rooms/SuperiorStudioApartment/4.jpg',

                                    ])
                                } />
                            <div class="ri-text">
                                <table className="table table-responsive">
                                    <tbody>
                                        <tr>
                                            <td class="r-o">{t('rooms.size')}</td>
                                            <td>40 {t('rooms.sizedesc')}</td>
                                        </tr>
                                        <tr>
                                            <td class="r-o">{t('rooms.desc')}</td>
                                            <td>{t('rooms.desc3')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.capacity')}</td>
                                            <td>{t('rooms.capacitydesc1')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.beds')}</td>
                                            <td>{t('rooms.bedsdesc')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.services')}</td>
                                            <td>{t('rooms.servicesdesc')}</td>
                                        </tr>

                                    </tbody>
                                </table>
                                <a target="_blank"
                                    rel="noopener noreferrer" href="https://www.booking.com/hotel/gr/rafkon-myrina-apartments.en-gb.html?lang=en-gb&soz=1&lang_changed=1#room_1026666602" class="primary-btn">{t('rooms.more')}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div className="room-item">
                        <h4>{t('rooms.ground')}</h4>
                        <h3><span></span></h3>
                            <img src="./img/rooms/ApartmentGroundFloor/1.jpg" alt="Rafkon Ground Floor Appartment" 
                            onClick={() =>
                                    handleImageClick([
                                        './img/rooms/ApartmentGroundFloor/1.jpg',
                                        './img/rooms/ApartmentGroundFloor/2.jpg',
                                        './img/rooms/ApartmentGroundFloor/3.jpg',
                                        // './img/rooms/ApartmentGroundFloor/4.jpg',
                                

                                    ])
                                } />
                            <div class="ri-text">
                                <table className="table table-responsive">
                                    <tbody>
                                        <tr>
                                            <td class="r-o">{t('rooms.size')}</td>
                                            <td>44 {t('rooms.sizedesc')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.desc')}</td>
                                            <td>{t('rooms.desc4')}</td>
                                        </tr>
                                        <tr>
                                            <td class="r-o">{t('rooms.capacity')}</td>
                                            <td>{t('rooms.capacitydesc1')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.beds')}</td>
                                            <td>{t('rooms.bedsdesc')}</td>
                                        </tr>

                                        <tr>
                                            <td class="r-o">{t('rooms.services')}</td>
                                            <td>{t('rooms.servicesdesc')}</td>
                                        </tr>

                                    </tbody>
                                </table>
                                <a target="_blank"
                                    rel="noopener noreferrer" href="https://www.booking.com/hotel/gr/rafkon-myrina-apartments.en-gb.html?lang=en-gb&soz=1&lang_changed=1#room_1026666603" class="primary-btn">{t('rooms.more')}</a>
                            </div>
                        </div>
                    </div>
                    {/* Add more slides as needed */}
                </div>
            </div>
            {/* Bootstrap Modal με Carousel */}
            <div
                className="modal fade"
                id="imageModal"
                tabIndex="-1"
                aria-labelledby="imageModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-body">
                            <Carousel
                                selectedItem={currentIndex}
                                onChange={(index) => setCurrentIndex(index)}
                                showThumbs={false}
                                showStatus={false}
                                infiniteLoop
                                emulateTouch
                                dynamicHeight={false}
                                useKeyboardArrows={true}
                            >
                                 {modalImages.map((imgSrc, idx) => (
                        <div key={idx} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img
                                src={imgSrc}
                                alt={`Room ${idx + 1}`}
                                style={{
                                    maxHeight: '100%',
                                    maxWidth: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    ))}
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Rooms;
